import _classCallCheck from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/createClass";
import { qualifierToJson } from "./qualifierToJson.js";
export var QualifierModel = /*#__PURE__*/function () {
  function QualifierModel() {
    _classCallCheck(this, QualifierModel);

    this._qualifierModel = {};
  }

  _createClass(QualifierModel, [{
    key: "toJson",
    value: function toJson() {
      return qualifierToJson.apply(this);
    }
  }]);

  return QualifierModel;
}();